module.exports = __webpack_public_path__ + "static/media/si.fb87a786.svg";